/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="onlinePresenceSettings.module.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/baseClasses/dataMaintenanceContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.OnlinePresenceSettings {
    "use strict";

    export class OnlinePresenceSettingsContext extends Meevo.Components.CommonClasses.CommonContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.CommonClasses.ICommonDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $scope: angular.IScope,
                    protected $translate: angular.translate.ITranslateService,
                    protected $mdDialog: ng.material.IDialogService,
                    protected $q: angular.IQService,
                    protected $rootScope: ng.IRootScopeService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            // TODO Change security key tab "Edit"
            this.buildCrudSecurityKeysBase(this.securityKeys.MARKETING_ONLINEPRESENCESETTINGS);
            // initialize endpoint
            this.baseEndpoint = appSettings.API_ENDPOINTS.onlinePresenceSettings;
            // initialize template paths
            this.sectionTemplatePath = "app/plugins/onlinePresenceSettings/sectionViews/";

            this.initializeSections();
        }

        /**
         * Responsible for initializing all sections belonging to the maintenance service.
         * @return {}
         */
        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsCommonDataService = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                isPrimarySection: false,
                handlesOwnCrud: false,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                identityService: this.identityService,
                dataService: this.dataService,
                noun: Meevo.Model.NounEnum.OnlinePresenceSettings,
                busyService: this.busyService,
            };

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MARKETING_ONLINEPRESENCESETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {

                this.sections.push(new MainSection(_.extend({}, baseSectionProps, {
                    displayNameContentKey: 'LABEL_MAIN',
                    template: 'main.html',
                    isPrimarySection: true,
                    sectionEndpoint: this.identityService.locationId,
                    sectionSecurityKey: this.securityKeys.MARKETING_ONLINEPRESENCESETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                }), this.modalService, this.$rootScope, this.appSettings, this.$translate, this.$q, this));
            }

            this.activate();
        }

         save() {
             let selectedSection = <any>this.selectedSection;

             if(selectedSection instanceof MainSection) {
                 return selectedSection.dataSave();
             }
         }

        /**
         * Responsible for initializing the header of the maintenance service.
         * This gets called only if isPrimarySection = true.  It supplies the model loaded
         * for the section to the method so that dynamic content can populate the header.
         * @return {}
         */
        initializeHeader(model: any): void {}
    }
}
